// src/utils/nokkuNaal.js
import React from 'react';

export const pirai = (input) => {
    console.log("pirai", input);
    switch (input) {
        case "1":
            return (
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <img src="/icon/pirai1.png" alt="தேய்பிறை" width={30} height={30}/>
                    <span>தேய்பிறை</span>
                </div>
            );

        case "2":
            return (
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <img src="/icon/pirai2.png" alt="வளர்பிறை" width={30} height={30}/>
                    <span>வளர்பிறை</span>
                </div>
            );

        case "-1":
            return (
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <img src="/blackmoon.png" alt="அமாவாசை" width={30} height={30}/>
                    <span>அமாவாசை</span>
                </div>
            );

        case "-2":
            return (
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <img src="/fullmoon.png" alt="பௌர்ணமி" width={30} height={30}/>
                    <span>பௌர்ணமி</span>
                </div>
            );
        default:
            return null;
    }
};
